export default {
    videos: 'Vídeos',
    data_consumed: 'Dados consumidos (mb)',
    size: 'Tamanho (Mb)',
    lms_link: 'Ligação LMS',
    video: 'Vídeo',
    no_file: 'Não existe nenhum ficheiro',
    text_upload_file: 'Começar a carregar um novo ficheiro',
    upload: 'Upload',
}